import {defaultState} from './state';
import * as LoginActions from '../actions/LoginActions';
import * as ProfileActions from '../actions/ProfileActions';
import * as UIActions from '../actions/UIActions';

const profile = (state = defaultState.profile, action) => {

    switch (action.type) {
        case ProfileActions.GOT_PROFILE_INFO_ACTION.name:
            return {
                ...state,
                userId: action.userId,
                email: action.email,
                firstName: action.firstName,
                lastName: action.lastName,
                groups: action.groups,
                roles: action.roles,
            };
        case LoginActions.SSO_GOT_TOKEN_BY_CODE.name:
            return {
                ...state,
                accessToken: action.accessToken,
                refreshToken: action.refreshToken
            };
        case LoginActions.LOGOUT_SUCCESS_ACTION.name:
        case UIActions.CLEAN_STATE_ACTION.name:
            return defaultState.profile;
        default:
            return state;
    }
};

export default profile;